import { base64EncodeString } from './encoding'

const getHttpBasicAuth = (username: string, password: string): string => {
  const base = `${username}:${password}`
  return `Basic ${base64EncodeString(base, 'utf-8')}`
}

export default getHttpBasicAuth
